import { Component, OnInit, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core'
import { ModalPopupsService } from '../../modal-popups.service'

@Component({
    selector: 'app-hawaii-message-popup',
    templateUrl: './hawaii-message.component.html',
    styleUrls: ['./hawaii-message.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class HawaiiMessagePopupComponent implements OnInit {
  constructor(public modalPopups: ModalPopupsService) {}

  @Input() additionalClasses = ''
  @Input() isMobile = false
  @Output() closed: EventEmitter<unknown> = new EventEmitter()

  close() {
    this.closed.emit(true)
  }

  ngOnInit(): void {
  }

}
